import React, {useEffect, useState} from "react";
import {Loading} from '../components/Loading'
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Typography from '@material-ui/core/Typography'
import TuneIcon from '@material-ui/icons/Tune';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import CropIcon from '@material-ui/icons/Crop';
import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined';
import RotateLeftOutlinedIcon from '@material-ui/icons/RotateLeftOutlined';
import FlipIcon from '@material-ui/icons/Flip';
import Button from "@material-ui/core/Button";
import {IconButton, makeStyles} from "@material-ui/core";
import {lighten} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    controlsWrapper: {
        marginTop: 16,
        background: '#32373D',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        height: '100%',
        width: 200,
        padding: 16,
        borderRadius: 16,
        '& .MuiButton-root': {
            margin: `4px 0`
        },
        '& > div': {
            padding: '8px 0',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            '& > .MuiTypography-root': {
                flex: '1',
            },
        }
    },
    cancelButton: {
        color: theme.palette.getContrastText(theme.customColors.yellow),
        backgroundColor: theme.customColors.yellow,
        '&:hover': {
            backgroundColor: lighten(theme.customColors.yellow, '0.2'),
        },
    },
}))

export default function ImageEditor({image, handleUpdate, handleCancel, isEditing, outputHeight, aspectRatio, editorHeight, exportType}) {
    const classes = useStyles();

    const [cropper, setCropper] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
    }, [isEditing])

    const handleSave = () => {
        if (typeof cropper !== "undefined") {
            const croppedData = cropper.getCroppedCanvas().toDataURL(exportType, 0.6);
            const data = cropper.getData();
            handleUpdate({
                ...image,
                editedUri: croppedData,
                editData: data,
            })
        }
    };

    /*
     * https://fengyuanchen.github.io/cropperjs/
     */

    const toggleCrop = () => {
        if (typeof cropper !== "undefined") {
            const cropBoxData = cropper.getCropBoxData();
            if (cropBoxData && Object.keys(cropBoxData).length === 0) {
                cropper.crop()
            } else {
                cropper.clear()
            }
        }
    }

    const onReset = () => {

        if (typeof cropper !== "undefined") {
            cropper.reset();
            cropper.clear();

        }
    }

    const onRotate = (deg) => () => {
        if (typeof cropper !== "undefined") {
            cropper.rotate(deg)
        }
    }
    const onZoom = (percentage) => () => {
        if (typeof cropper !== "undefined") {
            cropper.zoom(percentage)
        }
    }

    const onFlip = (direction) => () => {
        if (typeof cropper !== "undefined") {
            const {scaleX, scaleY} = cropper.getData();
            if (direction === 'vertical') {
                cropper.scaleY(scaleY === 1 ? -1 : 1);
            } else {
                cropper.scaleX(scaleX === 1 ? -1 : 1);
            }
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', height: isEditing ? 'auto' : '100%'}}>
            <div style={{width: '100%', minWidth: 800, maxWidth: 800, margin: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', height: isEditing ? editorHeight : outputHeight}}>
                {
                    !isEditing ? (
                        <img src={image?.editedUri} height={outputHeight} alt="Edited preview" />
                    ) : (
                        <>
                            {(loading) && <Loading />}
                            <Cropper
                                key={image.originalUri} //todo:replacewithid
                                src={image.originalUri}
                                style={{height: editorHeight, width: "100%"}}
                                aspectRatio={aspectRatio}
                                data={image.editData}
                                viewMode={2}
                                autoCrop={true}
                                dragMode={'none'}
                                minContainerWidth={800}
                                ready={() => setLoading(false)}
                                background={false}
                                responsive={true}
                                checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                                onInitialized={(instance) => {
                                    setCropper(instance);
                                    instance.setData(image.editData)
                                }}
                                guides={true}
                            />
                        </>
                    )
                }

            </div>
            {

                !isEditing ? (
                    null
                ) : (
                    <div className={classes.controlsWrapper}>
                        <div>
                            <TuneIcon style={{flex: '1'}} />
                            <Button variant="contained" color="secondary" disableElevation onClick={onReset} style={{background: 'tomato'}}>Reset</Button>
                        </div>
                        <div>
                            <Typography variant="body2">Crop</Typography>
                            <IconButton variant="contained" disableElevation onClick={toggleCrop}><CropIcon /></IconButton>
                        </div>
                        <div>
                            <Typography variant="body2">Zoom</Typography>
                            <IconButton variant="contained" disableElevation onClick={onZoom(0.1)}><ZoomInIcon /></IconButton>
                            <IconButton variant="contained" disableElevation onClick={onZoom(-0.1)}><ZoomOutIcon /></IconButton>
                        </div>
                        <div>
                            <Typography variant="body2">Rotate</Typography>
                            <IconButton variant="contained" disableElevation onClick={onRotate(-90)}><RotateLeftOutlinedIcon /></IconButton>
                            <IconButton variant="contained" disableElevation onClick={onRotate(90)}><RotateRightOutlinedIcon /></IconButton>
                        </div>
                        <div>
                            <Typography variant="body2">Flip</Typography>
                            <IconButton variant="contained" disableElevation onClick={onFlip('horizontal')}><FlipIcon /></IconButton>
                            <IconButton variant="contained" disableElevation onClick={onFlip('vertical')}><FlipIcon style={{transform: 'rotate(90deg)'}} /></IconButton>
                        </div>
                        <div>
                            <Button variant="contained" className={classes.cancelButton} disableElevation onClick={handleCancel}>Cancel</Button>
                            <Button variant="contained" color="primary" disableElevation onClick={handleSave}>Save</Button>
                        </div>
                    </div>
                )

            }
        </div >
    )
}
